import styled from "styled-components";
import { Project } from "../../../../constants/projects";
import { Link } from "react-router-dom";
import { media, typographyV2 } from "../../../../constants/styles";

interface Props {
    info: Project;
}
const NextProject: React.FC<Props> = ({ info }) => {

    return (
        <Container to={`/project/${info.key}`} image={info.nextBanner}>
            <TextContainer>
                <p>Next Project</p>
                <h2>{info.title}</h2>
            </TextContainer>
            <Dim />
            <Blur />
        </Container>
    )
};

export default NextProject

const Blur = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: backdrop-filter .3s;
    backdrop-filter: blur(0px);
`;
const Dim = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #000;
    opacity: .4;
`;

const Container = styled(Link) <{ image: string }>`
    position: relative;
    width: 100%;
    background: url(${({ image }) => image}) no-repeat center center / cover;
    transition: background-size .3s;

   &:active {
        & > ${Blur} {
            backdrop-filter: blur(20px);
        }
        background-size: 110%;
   }

    
  @media (hover: hover) {
    &:hover {
        & > ${Blur} {
            backdrop-filter: blur(20px);
        }
        background-size: 110%;
   }
   }
`;
const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-items: center;
    justify-content: center;
    padding: 120px 24px;
    color: #fff;
    position: relative;
    z-index: 2;

    & > p {
        font-size: 24px;
        line-height: 34px;
        font-weight: 500;
    }
    & > h2 {
        font-size: 48px;
        line-height: 68px;
        font-weight: 700;
    }

    ${media.TABLET} {
        padding: 80px 24px;
    }

    ${media.MOBILE} {
        padding: 60px 24px;
        gap: 16px;
        & > p {
            ${typographyV2.BODY_5_M};
        }
        & > h2 {
            ${typographyV2.HEADING_3_B};
        }
    }
`;